module.exports = (__webpack_require__(6671))(70);